<template>
  <div class="home" clstag="A05R|111425" :data-qidian-ext="JSON.stringify({yxfk: 'ptcpbDailyWithdrawal*平台产品部_天天提鹅*A05R'})" v-on:click.once="appTouch">
    <SystemUpgrade v-if="isOffLine"></SystemUpgrade>
    <template v-else>
    <MessageScroll @closeEvent="closeMessage" />

    <template v-if="userType == 1">
      <template v-if="resourceLoaded">
        <!-- <SlideLayer v-if="newUserType==2" @success="handleSuccess()"></SlideLayer> -->
        <div class="main-layer">
          <!-- <div class="empty-box"></div> -->
          <div :class="['header-box', scrollAnimate ? 'scroll-animation' : '']">
            <div class="left-area left-area-height">
              <div class="egg-icon"></div>
              <div class="egg-num udc-bold">{{ eggNumFix }}</div>
              <div class="change-gold-btn" @click="jumpToGoldFloor" clstag="A05R|clk_top_coin">{{ pointTopBubble }}</div>
            </div>
            <div class="right-area">
              <div class="music-btn" :clstag="pushStates ? 'A05R|clk_push_on' : 'A05R|clk_push_off'" @click="changePushStates">{{ pushStates ? '关闭提醒' : '打开提醒' }}</div>
              <div class="music-btn" clstag="A05R|clk_top_music" @click="changeMusicStates">{{ musicStates ? '音乐开' : '音乐关' }}</div>
              <a class="config-btn"  @click="handleClickLottie('https://storage.jd.com/protocols/format/d401159662445cc2950ceebdc700c60e.html')" clstag="A05R|clk_top_rules">规则</a>
              <a class="service-btn"  @click="handleClickLottie('https://m-jtalk.jd.com/hindex.htm?entrance=23787&source=h5&companyId=1')" clstag="A05R|clk_top_contact">客服</a>
            </div>
            <div class="scroll-board">
              <div class="scroll-area">
                <div class="scroller" :style="scrollerStyle">
                  <div class="scroll-text" v-for="item in scrollTextAry" :key="item.id">{{ item }}</div>
                  <div class="scroll-text" v-for="item in scrollTextAry" :key="item.id">{{ item }}</div>
                </div>
              </div>
              <!--     <router-link class="draw-icon" to="/gift" v-if="extensionFlag"
                                              clstag="A05R|clk_op_coin"></router-link>-->
            </div>
          </div>
          <div class="bg-box">
            <div class="sky"></div>
            <div class="cloud-area">
              <div class="cloud-1"></div>
              <div class="cloud-2"></div>
            </div>
            <div class="balloon"></div>
            <div class="left-building"></div>
            <div class="right-building"></div>
            <div class="ground"></div>
            <div v-if="showConfig.showLeftLottie&&showConfig.lottieUrl&&showConfig.lottieLink">
            <div class="left-lottie" ref="leftLottie"></div>
            <div class="left-lottie lottie2"  clstag="A05R|102319" @click="handleClickLottie(showConfig.lottieLink)"></div>
            </div>
            <div class="right-light"></div>
          </div>
          <!--<div class="ad-stage">
                           <div class="ad-ele">
                               <a class="block" :href="activityJumpUrl"><img class='pct100'
                                                                             src="../assets/images/ad-ele.png"></a>
                           </div>
                       </div>-->
          <div class="front-box">
            <div class="main-stage">
              <div v-if="collectEggNum > 0" class="main-btn" @click="collectEgg" clstag="A05R|clk_getegg" :data-qidian-ext="JSON.stringify({yxfk: 'ptcpbDailyWithdrawal*平台产品部_天天提鹅*提鹅收蛋'})">
                <div class="bt-package-tips" v-if="hasTodayPackage">
                  <span>提鹅再得{{ todayPackageNum }}元白条提额包</span>
                </div>
              </div>
              <div v-else class="main-btn-disable" :class="isStop?'main-btn-disable2':''" @click="showMissionPanel" clstag="A05R|113751"></div>
              <div class="exp-box">
                <div class="exp-bar-box">
                  <div class="exp-bar" :style="'width:' + (currentLevelExp / nextLevelExp) * 100 + '%'">
                    <div class="exp-bar-slice"></div>
                  </div>
                  <div class="exp-info udc-bold" v-if="currentLevelExp < nextLevelExp">{{ currentLevelExp }} / {{ nextLevelExp }}</div>
                  <div class="exp-info font-bold" v-else>MAX</div>
                </div>
                <div class="level-info">Lv{{ userLevel }} {{ levelName }}</div>
                <div class="exp-tips" @click="alertDialog({ type: 6 })" clstag="A05R|12820"></div>
              </div>
              <div class="stage-egg">
                <div v-if="!isStop" class="stage-num udc-bold">{{ collectEggNumFix }}/{{ basketSize }}</div>
                <div v-if="!isStop" class="next-egg-board">
                  <template v-if="canCreateEgg">
                    <div class="next-egg-des">距下枚鹅蛋还剩</div>
                    <div class="next-egg-time udc-bold">{{ nextEggTimeFix }}</div>
                  </template>
                  <template v-else>
                    <div class="no-egg" :class="newUserType!=1?'':'noMore'">{{newUserType!=1?'下不动啦':'今日鹅蛋已达上限'}}</div>
                  </template>
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="goose-box" @click="gooseClick()" clstag="A05R|clk_touchgoose">
              <Goose :updateEggPoint="!scrollAnimate" ref="goose"></Goose>
              <div v-if="currentChatText" class="goose-chat" :class="talking ? 'chat-show' : 'chat-hide'">
                <span>{{ currentChatText }}</span>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="panel-icon-box">
              <!-- <a class="check-icon" clstag="A05R|clk_checked" href="https://m.jr.jd.com/jdbt/others/html/amount-history.html?channelName=00008"></a> -->
              <!-- <div class="package-icon" @click="showPropPanel"
                                  clstag="A05R|clk_dj"></div>-->
              <img v-for="(item,index) in activityListFilter" :key="index" :clstag="item.clstag"  class="coupon-icon" :src="item.icon" @click="handleActivity(item.link)" alt="">
              <div v-if="!isStop" class="mission-icon" @click="showMissionPanel" clstag="A05R|clk_task">
                <div class="red-tips ani-icon-05" v-if="bubbleText">{{ bubbleText }}</div>
              </div>
            </div>
          </div>
          <!-- 懒加载 -->
          <div class="shop-layer">
            <GoldShop :eggNum="eggNum" v-on:change-gold="goldChange" ref="goldShop" :scoreUnits="pointExchangeWindowDesc" :enablePoint="enablePoint"></GoldShop>
            <btGoods></btGoods>
          </div>
        </div>
      </template>
      <LoadingLayer v-on:resource-loaded="finishLoading"></LoadingLayer>
      <GuideLayer v-if="guideShow && resourceLoaded" v-on:guide-finish="guideFinish"></GuideLayer>
      <audio src="../assets/sound/bgm.mp3" preload loop ref="soundBgm"></audio>
      <audio src="../assets/sound/click.mp3" preload ref="soundClick"></audio>
      <audio src="../assets/sound/collect.mp3" preload ref="soundCollect"></audio>
    </template>

    <template v-else-if="userType == 2">
      <ForbiddenLayer></ForbiddenLayer>
    </template>

    <template v-else-if="userType == 3">
      <OpenBtLayer></OpenBtLayer>
    </template>

    <div v-if="missionShow">
      <keep-alive>
        <MissionLayer v-on:panel-hide="hideMissionPanel" v-on:get-reward="getMissionReward" v-on:show-goldorder="showGoldOrder" v-on:code-error="getUserType"></MissionLayer>
      </keep-alive>
    </div>
    <div v-if="dialogShow">
      <Dialog v-on:dialog-hide="dialogHide" :config="dialogConfig" :scoreUnits="pointExchangeWindowDesc"></Dialog>
    </div>
    <div v-if="toastShow" class="game-toast ">
      {{ toastText }}
    </div>
    <div v-if="goldOrderShow">
      <GoldOrder v-on:layer-hide="dialogHide"></GoldOrder>
    </div>
    <div v-if="giftEggShow">
      <GiftEggs v-on:layer-hide="dialogHide" :giftEggType="giftEggType" :giftEggNum="giftEggNum" v-on:add-eggs="getMissionReward"></GiftEggs>
    </div>
    <!--<div v-if="propShow">
            <keep-alive>
                <PropLayer v-on:panel-hide="hideMissionPanel" v-on:props-use1="showToast('花瓣雨道具激活成功，快去提鹅收蛋使用')"
                           v-on:props-use2="showToast('翻倍卡道具激活成功，快去提鹅收蛋使用')"
                           v-on:code-error="getUserType"></PropLayer>
            </keep-alive>
        </div>-->
    <yt-comp page-id="2955"></yt-comp>
    <!-- 乐高添加到首页组件 -->
    <!-- <YTCompVue v-if="showYT"></YTCompVue> -->
    </template>
  </div>
</template>
<style rel="stylesheet/scss" lang="scss">
.empty-box {
  width: 100%;
  height: 0.36rem;
  position: absolute;
  top: 0;
  background-color: #3A23EB;
  z-index: 1;
}

.scroll-animation {
  animation: scrollUp 0.5s ease alternate forwards;
}

@keyframes scrollUp {
  0% {
    top: 0.36rem;
  }
  100% {
    top: 0;
  }
}


//头部
.header-box {
  width: 100%;
  height: 0.65rem;
  // height: 1.01rem;
  background-image: url('#{$path}/home/head-bg.png');
  position: absolute;
  top: 0.36rem;
  left: 0;
  z-index: 2;
  @include singleBg;
  .left-area {
    position: absolute;
    left: 0.02rem;
    top: 0;
    height: 100%;
  }
  .left-area-height {
    position: absolute;
    left: 0.02rem;
    top: 0;
    height: 100%;
  }
  .egg-icon {
    width: 0.32rem;
    height: 0.4rem;
    position: absolute;
    left: 0.13rem;
    background-image: url('#{$path}/home/egg-icon.png');
    @include singleBg;
    top: 50%;
    margin-top: -0.19rem;
  }
  .egg-num {
    color: #fff;
    position: absolute;
    left: 0.5rem;
    top: 0.08rem;
    font-size: 0.18rem;
    text-align: left;
  }
  .change-gold-btn {
    background-color: #ffdc7e;
    white-space: nowrap;
    color: #924a03;
    font-size: 0.1rem;
    border-radius: 0.1rem;
    width: 0.6rem;
    height: 0.18rem;
    line-height: 0.18rem;
    text-align: center;
    position: absolute;
    left: 0.5rem;
    top: 0.37rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 0.04rem;
  }

  .right-area {
    position: absolute;
    display: flex;
    right: 0.03rem;
    height: 0.45rem;
    top: 0.01rem;
    align-items: center;
    justify-content: flex-end;
    color: #fff;
  }
  .music-btn,
  .config-btn,
  .service-btn {
    padding: 0 0.07rem;
    line-height: 1;
    font-size: 0.12rem;
    color: #fff;
  }
  .music-btn,
  .config-btn {
    border-right: 1px solid rgba(255, 255, 255, 0.4);
  }
  .scroll-board {
    width: 1.64rem;
    height: 0.34rem;
    background-image: url(#{$path}/home/scroll-board.png);
    @include singleBg;
    position: absolute;
    right: 0.05rem;
    top: 0.44rem;
  }
  .scroll-area {
    width: 1.5rem;
    height: 0.22rem;
    margin: 0.1rem auto 0 auto;
    overflow: hidden;
  }
  .scroll-text {
    color: #fff;
    font-size: 0.11rem;
    height: 0.22rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .scroller {
    transition: all 0.3s ease-out;
    transform: translateY(0);
  }
  .draw-icon {
    display: block;
    width: 0.72rem;
    height: 0.57rem;
    background-image: url(#{$path}/home/gift-icon.png);
    @include singleBg;
    position: absolute;
    right: -0.05rem;
    top: 0.4rem;
    animation: shake 1.5s infinite both;
  }
  @keyframes shake {
    0% {
      transform: scaleX(1);
    }
    10%,
    20% {
      transform: scale3d(0.98, 0.98, 0.98) rotate(-3deg);
    }
    30%,
    50%,
    70%,
    90% {
      transform: scale3d(1, 1, 1) rotate(3deg);
    }
    40%,
    60%,
    80% {
      transform: scale3d(1, 1, 1) rotate(-3deg);
    }
    to {
      transform: scaleX(1);
    }
  }
}
//背景层
.bg-box {
  height: 100vh;
  position: relative;
  overflow: hidden;
  .sky {
    height: 100vh;
    background: #dd7aff url(#{$path}/home/sky.png) no-repeat center top;
    background-size: cover;
  }
  .ground {
    width: 100%;
    height: 2.5rem;
    position: absolute;
    bottom: 0;
    background: url(#{$path}/home/ground.png) no-repeat center bottom;
    background-size: cover;
  }
  .left-building {
    position: absolute;
    left: 0;
    bottom: 1.05rem;
    width: 1.28rem;
    height: 4.79rem;
    background-image: url('#{$path}/home/left-building.png');
    @include singleBg;
  }
  .left-lottie {
    position: absolute;
    left: -0.065rem;
    bottom: 1.6rem;
    width: 0.84rem;
    height: 1.5rem;
  }
  .lottie2{
    z-index: 2;
  }

  .right-building {
    position: absolute;
    right: 0;
    bottom: 1.05rem;
    width: 1.05rem;
    height: 4.97rem;
    background-image: url('#{$path}/home/right-buildings.png');
    @include singleBg;
  }
  .right-light {
    position: absolute;
    right: 0;
    bottom: 1.75rem;
    width: 0.955rem;
    height: 1.275rem;
    background-image: url('https://img30.360buyimg.com/jr_image/jfs/t1/104454/22/21569/16488/63ede6fbF47e029ca/79b696e375ac6853.png');
    @include singleBg;
  }
  .balloon {
    position: absolute;
    left: 50%;
    top: 15%;
    width: 0.62rem;
    height: 1.57rem;
    background-image: url('#{$path}/home/balloon.png');
    @include singleBg;
    animation: balloon 3s infinite ease-in-out both;
  }
  .cloud-area {
    position: absolute;
    left: 0;
    top: 15%;
    width: 100%;
    height: 1rem;
  }
  .cloud-1 {
    position: absolute;
    right: -0.5rem;
    width: 0.5rem;
    height: 0.3rem;
    background-image: url('#{$path}/home/cloud-1.png');
    @include singleBg;
    animation: cloudFly 20s infinite linear both;
  }
  .cloud-2 {
    position: absolute;
    width: 0.4rem;
    top: 0.3rem;
    right: -0.4rem;
    height: 0.24rem;
    background-image: url('#{$path}/home/cloud-2.png');
    @include singleBg;
    animation: cloudFly 15s 2s infinite linear both;
  }
}
@keyframes balloon {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-0.1rem);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes cloudFly {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-5rem);
  }
}
//前景层
.front-box {
  width: 100%;
  height: 80vh;
  position: absolute;
  top: 20vh;
  left: 0;
  .ad-stage {
    position: absolute;
    left: 0;
    bottom: 1.5rem;
    width: 0.67rem;
    height: 0.83rem;
    background-image: url(#{$path}/home/ad-stage.png);
    @include singleBg;
  }
  .ad-ele {
    width: 0.39rem;
    height: 0.4rem;
    position: absolute;
    left: 50%;
    margin-left: -0.2rem;
    bottom: 0.7rem;
  }
  //舞台
  .main-stage {
    position: absolute;
    bottom: 0.6rem;
    left: 50%;
    margin-left: -1.51rem;
    width: 3.05rem;
    height: 2.18rem;
    background-image: url('#{$path}/stage/main-stage.png');
    @include singleBg;
  }
  //按钮
  .main-btn {
    position: absolute;
    bottom: 0.18rem;
    left: 50%;
    margin-left: -0.93rem;
    width: 1.86rem;
    height: 0.64rem;
    background-image: url('#{$path}/stage/main-btn.png');
    @include singleBg;
    &:active {
      background-image: url('#{$path}/stage/main-btn-pushed.png');
    }
  }
  .bt-package-tips {
    position: absolute;
    padding: 0 0.05rem;
    height: 0.22rem;
    line-height: 0.22rem;
    top: 0;
    right: 0;
    background: rgba(255, 38, 42, 0.9);
    color: #fff;
    border-radius: 0.22rem 0.22rem 0.22rem 0px;
    white-space: nowrap;
    font-size: 0.11rem;
    z-index: 5;
    font-weight: bold;
  }
  .main-btn-disable {
    position: absolute;
    bottom: 0.18rem;
    left: 50%;
    margin-left: -0.93rem;
    width: 1.86rem;
    height: 0.64rem;
    background-image: url('#{$path}/stage/main-btn-disable.png');
    @include singleBg;
  }
  .main-btn-disable2 {
    background-image: url('https://kjimg10.360buyimg.com/jr_image/jfs/t1/223122/20/33111/30796/64bf7d22F058c2cc0/d99a17a693274e18.png');
    @include singleBg;
  }
  //收蛋提示
  .stage-egg {
    position: absolute;
    left: 0.46rem;
    bottom: 1.83rem;
    width: 0.41rem;
    height: 0.42rem;
    background-image: url(#{$path}/stage/stage-egg.png);
    @include singleBg;
  }
  .stage-num {
    color: #4922cb;
    font-size: 0.14rem;
    position: absolute;
    width: 100%;
    bottom: 0.08rem;
    text-align: center;
  }
  .next-egg-board {
    position: absolute;
    left: 50%;
    margin-left: -0.32rem;
    top: -0.35rem;
    width: 0.64rem;
    height: 0.32rem;
    background-color: rgba(30, 0, 198, 0.6);
    color: #fff;
    font-size: 0.07rem;
    text-align: center;
    line-height: 1;
    border-radius: 0.05rem;
    .triangle {
      position: absolute;
      left: 50%;
      margin-left: -0.05rem;
      top: 100%;
      border-width: 0.05rem;
      border-style: solid;
      border-color: rgba(30, 0, 198, 0.6) transparent transparent transparent;
    }
  }
  .next-egg-des {
    margin-top: 0.05rem;
    white-space: nowrap;
    text-align: center;
  }
  .next-egg-time {
    font-size: 0.14rem;
    margin-top: 0.01rem;
  }
  .no-egg {
    line-height: 0.3rem;
    font-size: 0.12rem;
    white-space: nowrap;
  }
  .noMore{
    font-size: 0.07rem;
  }
  //经验槽
  .exp-box {
    width: 1.8rem;
    height: 0.52rem;
    background-image: url(#{$path}/stage/exp-bar.png);
    @include singleBg;
    position: absolute;
    left: 50%;
    margin-left: -0.9rem;
    bottom: 0.88rem;
  }
  .exp-bar-box {
    width: 1.68rem;
    height: 0.17rem;
    position: absolute;
    bottom: 0.012rem;
    left: 0.06rem;
    overflow: hidden;
    border-radius: 0.5rem;
  }
  .exp-bar {
    width: 0;
    height: 100%;
    background-image: linear-gradient(180deg, #ffde91 0%, #fba118 50%, #f16000 100%);
    box-shadow: 0 0 2px 0 rgba(199, 100, 0, 0.16);
    border-radius: 0.5rem;
    overflow: hidden;
    transition: all 0.1s linear;
  }
  .exp-bar-slice {
    width: 100%;
    height: 100%;
    background: url(#{$path}/stage/exp-bar-slice.png) repeat-x;
    background-size: auto 100%;
    animation: sliceMove 0.8s infinite linear;
  }
  .exp-info {
    position: absolute;
    bottom: 0.02rem;
    color: #fff;
    width: 100%;
    text-align: center;
    line-height: 1;
    font-size: 0.13rem;
    text-shadow: 0 0 0.03rem rgba(65, 13, 165, 0.5);
  }
  .level-info {
    position: absolute;
    top: 0.15rem;
    color: #fff;
    width: 100%;
    width: 100%;
    text-align: center;
    font-size: 0.12rem;
    line-height: 1;
    font-weight: bold;
  }
  .exp-tips {
    position: absolute;
    right: -0.17rem;
    bottom: 0.03rem;
    width: 0.17rem;
    height: 0.17rem;
    background-image: url(#{$path}/stage/exp-tips.png);
    @include singleBg;
  }
  @keyframes sliceMove {
    0% {
      background-position: 0rem;
    }
    100% {
      background-position: 0.2rem;
    }
  }

  //右侧悬浮按钮
  .panel-icon-box {
    width: 0.55rem;
    position: absolute;
    right: 0.1rem;
    top: 0;
  }
  .check-icon {
    display: block;
    width: 0.51rem;
    height: 0.54rem;
    background-image: url(#{$path}/home/check-icon.png);
    @include singleBg;
    margin: 0 auto;
  }
  .mission-icon {
    width: 0.51rem;
    height: 0.54rem;
    background-image: url(#{$path}/home/mission-icon.png);
    @include singleBg;
    margin: 0 auto;
    margin-top: 0.15rem;
    position: relative;
  }
  .package-icon {
    width: 0.51rem;
    height: 0.54rem;
    background-image: url(#{$path}/home/package-icon.png);
    @include singleBg;
    margin: 0 auto;
    margin-top: 0.15rem;
    position: relative;
  }
  .coupon-icon {
    display: block;
    width: 0.51rem;
    height: 0.54rem;
    @include singleBg;
    margin: 0 auto;
    margin-top: 0.125rem;
    position: relative;
  }
  .red-tips {
    position: absolute;
    right: -0.06rem;
    top: -0.06rem;
    height: 0.16rem;
    overflow: hidden;
    color: #fff;
    background: #ff4444;
    padding: 0 0.03rem;
    border: 0.02rem solid #fffdeb;
    border-radius: 0.5rem 0.5rem 0.5rem 0.08rem;
    font-size: 0.1rem;
    line-height: 0.16rem;
    font-weight: bold;
  }
// SCSS_VAR_END
.ani-icon-05 {
  animation: ani-icon-05 8s ease-out infinite;
  transform: scale(0);
  opacity: 0;
  transform-origin: left bottom;
}

@keyframes ani-icon-05 {
  0%,
  100% {
    transform: scale(0);
    opacity: 0;
  }
  23%,
  77% {
    transform: scale(1.1);
    opacity: 1;
  }
  19%,
  79% {
    transform: scale(0);
    opacity: 0;
  }
  25%,
  75% {
    transform: scale(1);
    opacity: 1;
  }
}
}
//鹅
.goose-box {
  width: 1.3rem;
  height: 2.42rem;
  position: absolute;
  left: 50%;
  margin-left: -0.62rem;
  bottom: 2.5rem;
}
.goose-chat {
  position: absolute;
  left: 50%;
  top: -0.1rem;
  transform: translate3d(-50%, -110%, 0);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 2rem;
  padding: 0.05rem 0.1rem;
  font-size: 0.12rem;
  min-width: 1.6rem;
  z-index: 3;
  .triangle {
    position: absolute;
    left: 50%;
    margin-left: -0.06rem;
    top: 100%;
    border-width: 0.06rem;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.6) transparent transparent transparent;
  }
}
.chat-show {
  animation: chatShow 0.4s 1 ease-out both;
}
.chat-hide {
  animation: chatHide 0.4s 1 ease-out both;
}
//商店层
.shop-layer {
  position: relative;
  margin-top: -0.6rem;
}
@keyframes chatShow {
  0% {
    opacity: 0;
    transform: translate3d(-50%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(-50%, -110%, 0);
  }
}
@keyframes chatHide {
  0% {
    opacity: 1;
    transform: translate3d(-50%, -110%, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(-50%, -160%, 0);
  }
}
//toast
.game-toast {
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  max-width: 2rem;
  padding: 0.1rem 0.2rem;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 100;
  transform: translate3d(-50%, -50%, 0);
  animation: maskHide 0.3s 1s both;
  pointer-events: none;
  border-radius: 0.3rem;
}
</style>

<script>
//layer
// import SlideLayer from '@/components/SlideLayer.vue'
import SystemUpgrade from '@/components/SystemUpgrade.vue'
import ForbiddenLayer from '@/components/Forbidden.vue'
import OpenBtLayer from '@/components/OpenBt.vue'
import LoadingLayer from '@/components/Loading.vue'
import GuideLayer from '@/components/GuideLayer.vue'
import GoldShop from '@/components/GoldShop.vue'
import btGoods from '@/components/btGoods.vue'
import MissionLayer from '@/components/MissionLayer.vue'
import Dialog from '@/components/Dialog.vue'
import GoldOrder from '@/components/GoldOrder.vue'
//import PropLayer from '@/components/PropLayer.vue'
//animComponents
import Goose from '@/components/Goose.vue'
import GiftEggs from '@/components/GiftEggs.vue'

//scripts
import DeviceInfo from "./../scripts/deviceInfo";
import proHub from './../scripts/proHub'
import Tools from './../scripts/tools'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

//Global
import Global from './../scripts/Global'

// 引入消息组件
import MessageScroll from '../components/MessageScroll'
// import YTCompVue from '../components/YTComp.vue'
import lottie from 'lottie-web'

export default {
  name: 'home',
  data() {
    return {
      //游戏设置相关
      musicStates: false, //音乐开关
      pushStates: false, //推送开关,
      extensionFlag: false, //是否开启推广活动
      //游戏数据相关
      eggNum: 0, //用户总蛋数
      goldNum: 0, //用户金币数
      collectEggNum: 0, //小窝未收取蛋数,
      basketSize: 0,
      nextEggTime: 0, //下一个蛋的时间，
      userLevel: 1,
      levelName: '',
      currentLevelExp: 0,
      nextLevelExp: 1,
      //游戏文案信息相关
      bubbleText: '',
      scrollTextAry: null, //滚动文字数组,
      activityJumpUrl: 'javascript:;',
      scrollerStyle: {},
      chatStayTime: { 1: 3000, 2: 3000, 3: 10000, 4: 10000, 5: 10000, 6: 3000 },
      checkWaitTime: { 1: 2000, 2: 5000, 3: 5000, 4: 10000, 5: 10000, 6: 5000 },
      currentChatText: '',
      //游戏状态相关
      talkType: 0, //0:欢迎 1:篮子满了 2:今日提额 3:后续提鹅 4:篮子为空 5:点击互动
      userType: 0, //0:未获取到状态 1:正常用户 2:风控用户 3:白名单用户 4:未激活白条用户
      todayPackageNum: 0, //今日提额包数
      tomorrowPackageNum: 0, //明日提额包数
      talking: false, //是否在对话
      canCreateEgg: true, //是否还能下蛋
      resourceLoaded: false, //资源全部加载
      hasTodayPackage: false, //是否有今日白条提额包
      hasTomorrowPackage: false, //是否有明日白条提额包
      missionShow: false, //任务
      dialogShow: false, //弹窗
      goldOrderShow: false, //金口令
      guideShow: false, //新手引导
      toastShow: false, //toast展示与否
      toastText: '',
      //618相关
      giftEggShow: false, //是否展示618彩蛋
      propShow: false, //道具
      giftEggType: 0, // 1:花瓣雨 2：翻倍卡 3：鹅蛋
      giftEggNum: 0,
      // 2021-03-22 
      pointTopBubble: '- -',   // 标题
      scrollAnimate: false,
      pointExchangeWindowDesc: '',
      enablePoint: false,
      musicBtn: false,// 退到后台前音乐开关状态
      showYT: false,
      activityList:window.data_source_100003725?.activityList||[],
      leftPlayer: null,
      showConfig:window.data_source_100003725?.showConfig||{},
      isOffLine:window.data_source_100003725?.systemConfig?.isOffLine||false,
      isStop:window.data_source_100003725?.systemConfig?.isStop||false,
      newUserType:0, // 0:正常用户 1:风控用户 2：需要滑块验证用户
      isIncome:'', // 小金库任务标识
      // homeData:{}
    }
  },
  components: {
    OpenBtLayer,
    ForbiddenLayer,
    LoadingLayer,
    GuideLayer,
    MissionLayer,
    //PropLayer,
    GoldShop,
    btGoods,
    Dialog,
    GoldOrder,
    Goose,
    GiftEggs,
    MessageScroll,
    // YTCompVue,
    SystemUpgrade,
    // SlideLayer
  },
  created() {
    if(!this.isOffLine){
      this.setGlobal()
      // this.getData()
    }
  },
  // 监听App是否退到后台，关闭音乐播放
  mounted() {
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          if (this.musicStates) {
            this.musicStates = !this.musicStates
            this.$refs.soundBgm.pause()
            this.musicBtn = true
          }  
        } else {
          if(this.musicBtn){
            this.musicStates = !this.musicStates
            this.$refs.soundBgm.play()
          }
        }
    });

    this.showYT = true
  },
  beforeDestroy() {
    this.leftPlayer?.destroy()
  },
  computed: {
    eggNumFix() {
      return Tools.fixMoney(this.eggNum)
    },
    collectEggNumFix() {
      return Tools.fixZero(this.collectEggNum)
    },
    nextEggTimeFix() {
      return Tools.computeTime(this.nextEggTime)
    },
    activityListFilter(){
      let arr=this.activityList.filter((item,index)=>{
        return item.icon&&item.link
      })
      return arr
    }
  },
  methods: {
    handleSuccess(){
     this.initData(this.homeData)
     this.newUserType = 0
    },
    setGlobal() {
      Global.inviteId = Tools.getUrlString('shareId') || ''
      Global.channelLv = Tools.getUrlString('channelLv') || ''
      this.isIncome  = Tools.getUrlString('isIncome') || ''

      Global.currentSystem = Tools.getSystem()
      const initTimer=setTimeout(()=>{
        Global.riskDeviceInfo = JSON.stringify(DeviceInfo.getDeviceInfo() || {})
        this.getData()
        clearTimeout(initTimer)
      },500)
        
      // let risk_jd = getEidJoint() || {}
      // Global.riskDeviceInfo = JSON.stringify({
      //   eid: risk_jd.eid,
      //   fp: risk_jd.fp,
      //   token: risk_jd.token,
      // })
      
    },
    setShare(shareId) {
      let _url = 'https://active.jd.com/forever/btgoose?shareId=' + shareId + '&channelLv=share_' + Tools.getSystem() + '&sourceID=291&actflag=BEB5DD0349&isPay=N'
        
        if (!window.share) return
        window.share.setShare({
          title: '天天提鹅',
          shareToWx: true, //这里定义项目默认是否允许分享到微信 可选，默认true
          desc: '天天提鹅有惊喜',
          link: _url,
          imgUrl: 'https://img30.360buyimg.com/jr_image/jfs/t1/93975/21/13954/20755/5e5f6c60Efff3ee5a/f02ce38cd2a83cbf.png',
          shareSuccess: function() {
            proHub.get('toShare', { shareUuid: Global.inviteId }, (e) => {})
          },
        })


      // let _params =
      //   'reqData=' +
      //   encodeURIComponent(
      //     JSON.stringify({
      //       request: {
      //         url: _url,
      //         keyChannel: 'Wxfriends',
      //       },
      //     })
      //   )
        // 金口令下线
      // proHub.getOtherUrl('//ms.jr.jd.com/gw/generic/jrm/h5/m/build', _params, (result) => {
      //   Global.goldCode = result.data.code
      //   Global.goldCopySuccessText = result.data.copySuccessText
      //   if (!window.share) return
      //   window.share.setShare({
      //     title: '天天提鹅',
      //     shareToWx: false, //这里定义项目默认是否允许分享到微信 可选，默认true
      //     shareOrder: Global.goldCode, //这里传是否有金口令，如果有金口令，则会分享到微信，优先级高于shareToWx  可选，默认为空
      //     orderContent: Global.goldCopySuccessText, //这里是app内弹窗的文案，可选，默认是去微信粘贴给好友
      //     desc: '天天提鹅有惊喜',
      //     link: _url,
      //     imgUrl: 'https://img30.360buyimg.com/jr_image/jfs/t1/93975/21/13954/20755/5e5f6c60Efff3ee5a/f02ce38cd2a83cbf.png',
      //     shareSuccess: function() {
      //       proHub.get('toShare', { shareUuid: Global.inviteId }, (e) => {})
      //     },
      //   })
      // })
    },
    getData() {

        // 1.1.0 新增首页防刷功能
        let signData = {
          channelLv: Global.channelLv||"ttte",
          environment: Global.currentSystem||"jrApp",
          riskDeviceInfo: Global.riskDeviceInfo, //`{\"eid\":\"${Global.riskDeviceInfo}\"}`,
          shareUuid: Global.inviteId||"uuid",
        };
        let parameters = {
          qdPageId: 'A05R',
          mdClickId: 'A05R|111425',
          pageUrl: window.location.href,
          urlKey: window.location.origin + window.location.pathname,
          isSlider:0,
        };

      // console.log('---------',signData)

      proHub.get(
        'toDailyHome',
        {
          riskDeviceInfo: Global.riskDeviceInfo,
          parameters: parameters,
          timeSign: Math.random(),
          environment: Global.currentSystem||"jrApp",
          channelLv: Global.channelLv||"ttte",
          shareUuid: Global.inviteId||"uuid",
          sign: true,
          signData: signData,
        },
        (e) => {
          this.getUserType(e.code, () => {
            this.newUserType = e.data?.userType||0
            this.initData(e.data)
            Global.shareId = e.data.shareUuid || ''
            this.setShare(Global.shareId)
            if (e.data.pointTopBubble) this.pointTopBubble = e.data.pointTopBubble
            if (e.data.pointExchangeWindowDesc) this.pointExchangeWindowDesc = e.data.pointExchangeWindowDesc
            this.enablePoint = e.data.enablePoint
          })
        }
      )

      //乐高数据
      proHub.get('queryDailyRes', { pageId: '2956' }, (result) => {
        if (result.code == '0000' && result['data'] && result['data']['resultList']) {
          Global.btOpenData = result['data']['resultList'][0]
          Global.guideHandText = result['data']['resultList'][1]
          Global.goldShopBannerData = result['data']['resultList'][2]
        }
      })
    },
    initData(data) {
      let self = this
      this.eggNum = data.availableTotal //鹅蛋总数
      if(this.isStop){
        this.scrollTextAry = ['提鹅即将下线，请尽快兑换']
      }else{
        this.scrollTextAry = data.horseRaceLamp //跑马灯数据
        this.scrollText()
      }
      this.pushStates = data.push == 1 ? true : false //推送开关
      this.musicStates = data.muisc == 1 ? true : false //音乐开关
      this.musicBtn = this.musicStates
      this.extensionFlag = data.extensionFlag
      this.collectEggNum = data.grassEggTotal //小窝里的鹅蛋数
      this.basketSize = data.basketSize //小窝容量
      this.activityJumpUrl = data.activityJumpUrl || 'javascript:;' //广告链接
      this.isNewUser = data.novice == 1 ? false : true
      //this.isNewUser = true;
      this.bubbleText = data.bubble
      //等级相关
      this.userLevel = data.userLevelDto.level
      this.levelName = data.userLevelDto.levelName
      this.currentLevelExp = data.userLevelDto.userHaveEggNum
      this.nextLevelExp = data.userLevelDto.levelEggNum || this.currentLevelExp
      //是否还能孵蛋
      if (data.createEgg == '0') {
        this.canCreateEgg = true
        this.createEggTime(data.nextEggTime)
      } else {
        this.canCreateEgg = false
      }
      //是否有今日提额包
      if (data.withdraws && data.withdraws.risePackageVoList[0] && data.withdraws.risePackageVoList[0].status != 2) {
        this.hasTodayPackage = true
        this.todayPackageNum = data.withdraws.risePackageVoList[0].riseLimit
      }
      //是否有明日提额包
      if (data.withdraws && data.withdraws.risePackageVoList[1]) {
        this.hasTomorrowPackage = true
        this.tomorrowPackageNum = data.withdraws.risePackageVoList[1].riseLimit
      }
      //小鹅对话
      this.gooseTalkList = data.interactivePrompt
      if (!this.isNewUser) this.gooseTalk(1)
      /* //618彩蛋
                 if (data.propsType == 1) {
                     Global.flowerActive = true;
                 }
                 if (data.isFristLogin == 'true' && data.isSoePopup == 'true') {
                     if (this.isNewUser) {
                         this.needShowGiftEgg = true;
                     } else {
                         this.showGiftEggs();
                     }
                     return;
                 }*/
      //每日首次登陆签到礼包
      if (data.isFristLogin == 'true') {
        
        let _this = this;
        let signData = {
          channelLv: Global.channelLv||"clv",
          environment: Global.currentSystem||"jrApp",
          riskDeviceInfo: Global.riskDeviceInfo,
          shareUuid: Global.inviteId||"uuid",
        };
        let parameters = {
          qdPageId: 'A05R',
          mdClickId: '',
          pageUrl: window.location.href,
          urlKey: window.location.origin + window.location.pathname,
          isSlider:0,
        };
        
        proHub.get(
          'toDailySignIn',
          {
            riskDeviceInfo: Global.riskDeviceInfo,
            parameters: parameters,
            environment: Global.currentSystem||"jrApp",
            channelLv: Global.channelLv||"clv",
            shareUuid: Global.inviteId||"uuid",
            sign: true,
            signData: signData,
          },
          (e) => {
            // console.log("toDailySignIn:",e);
            if (e.code == '0000') {
              _this.alertDialog({
                type: 8,
                signAward: e.data.signAward,
                newUserType: self.newUserType,
                hideCb() {
                  self.getLevelInfo()
                },
              })
            }
          }
        )
      }
    },


    playMusic(type) {
      switch (type) {
        case 'bgm':
          this.$nextTick(() => {
            this.$refs.soundBgm.play()
          })
          break
      }
    },
    appTouch() {
      if (this.musicStates) this.playMusic('bgm')
    },
    getLevelInfo() {
      proHub.get('queryUserLevel', {}, (e) => {
        if (e.code == '0000') {
          if (this.userLevel < e.data.userLevelDto.level) {
            //升级了
            this.alertDialog({
              type: 7,
              level: e.data.userLevelDto.level,
              levelName: e.data.userLevelDto.levelName,
              rewardNum: e.data.upgradeInfoDto.rewardvalue,
            })
            this.refreshUserLevelInfo(e.data.userLevelDto)
          } else if (this.userLevel == e.data.userLevelDto.level) {
            //没升级
            this.refreshUserLevelInfo(e.data.userLevelDto)
          }
          this.eggNum = e.data.userEggNum
        }
      })
    },
    refreshUserLevelInfo(userLevelDto) {
      this.currentLevelExp = userLevelDto.userHaveEggNum
      this.nextLevelExp = userLevelDto.levelEggNum || this.currentLevelExp
      this.userLevel = userLevelDto.level
      this.levelName = userLevelDto.levelName
    },
    //动画方法
    scrollText() {
      let currentStep = 0
      let timer = setInterval(() => {
        currentStep++
        if (currentStep == this.scrollTextAry.length) {
          currentStep = 0
          this.scrollerStyle = { transform: 'translateY(-' + this.scrollTextAry.length * 0.22 + 'rem)' }
          setTimeout(() => {
            this.scrollerStyle = {
              transition: 'all 0s ease-out',
              transform: 'translateY(0)',
            }
          }, 300)
        } else {
          this.scrollerStyle = {
            transition: 'all 0.3s ease-out',
            transform: 'translateY(-' + currentStep * 0.22 + 'rem)',
          }
        }
      }, 3000)
    }, //弹幕滚动
    createEggTime(nextEggTime) {
      //收蛋倒计时
      let self = this
      this.nextEggTime = nextEggTime
      clearTimeout(self.createEggTimer)
      self.createEggTimer = setTimeout(() => {
        if (this.nextEggTime <= 0) {
          // 防刷与风控
              let signData = {
                channelLv: Global.channelLv||"ttte",
                environment: Global.currentSystem||"jrApp",
                riskDeviceInfo: Global.riskDeviceInfo,
                shareUuid: Global.inviteId||"uuid",
              };
              let parameters = {
              qdPageId: 'A05R',
              mdClickId: '',
              pageUrl: window.location.href,
              urlKey: window.location.origin + window.location.pathname,
              isSlider:0,
              };
          proHub.newPost('queryNextEggInfo', {
            riskDeviceInfo: Global.riskDeviceInfo,
              parameters: parameters,
              signData: signData,
              environment: Global.currentSystem||"jrApp",
              channelLv: Global.channelLv||"ttte",
              shareUuid: Global.inviteId||"uuid",
          }, (e) => {
            if (e.code == '0000') {
              if (e.data.createEgg == '0') {
                //还有蛋
                clearTimeout(self.createEggTimer)
                self.canCreateEgg = true
                self.collectEggNum = e.data.grassEggTotal //小窝里的鹅蛋数
                self.nextEggTime = e.data.nextEggTime
                self.createEggTime(e.data.nextEggTime)
              } else {
                self.canCreateEgg = false
                self.collectEggNum = e.data.grassEggTotal //小窝里的鹅蛋数
              }
            }
          })
        } else {
          this.nextEggTime--
          this.createEggTime(this.nextEggTime)
        }
      }, 1000)
    },
    gooseClick() {
      if (this.musicStates) {
        this.$refs.soundClick.play()
      }
      this.gooseTalk(6)
      this.$refs.goose.playClick()
    },
    gooseTalk(type, exchangeNum) {
      let self = this
      this.talking = true
      this.talkType = type
      try {
        if (exchangeNum) {
          this.currentChatText = Tools.shuffle(this.gooseTalkList[type])[0].content.replace(/{X}/, exchangeNum)
        } else {
          this.currentChatText = Tools.shuffle(this.gooseTalkList[type])[0].content
        }
      } catch (error) {}
      clearTimeout(this.talkTimer)
      clearTimeout(this.talkCheckTimer)
      this.talkTimer = setTimeout(() => {
        self.talking = false
        self.talkCheckTimer = setTimeout(() => {
          if (self.collectEggNumFix == self.basketSize && type != 2) {
            //篮子满了
            self.gooseTalk(2)
          } else if (self.hasTodayPackage && type != 4) {
            //今日提额
            self.gooseTalk(4, self.todayPackageNum)
          } else if (self.hasTomorrowPackage && type != 5) {
            //明日提鹅
            self.gooseTalk(5, self.tomorrowPackageNum)
          } else if (self.collectEggNumFix == 0) {
            //篮子空了
            self.gooseTalk(3)
          } else {
            self.gooseTalk(6)
          }
        }, self.checkWaitTime[type])
      }, this.chatStayTime[type])
    },
    //事件响应
    getUserType(code, cb) {
      switch (code) {
        case '0000': //正常用户
          this.userType = 1
          cb && cb()
          break
        case '0014': //空白组
          this.userType = 2
          break
        case '0012': //风控用户
          this.userType = 2
          break
        case '0005': //未开通白条
          this.userType = 3
          break
        case '0006':
          this.showToast('同时只能激活一个道具喔')
          break
        case '0007':
          this.showToast('操作频繁')
          break
        case '1030':
          this.showToast('活动火爆，请稍后重试')
          break
        /*case '0001':  //异常
                        this.userType = 2;
                        break;*/
        default:
          this.userType = 1
          break
      }
      //this.userType = 3;
    },
    finishLoading() {
      this.resourceLoaded = true
      if (this.isNewUser) {
        document.documentElement.scrollTop = 0
        this.guideShow = true
        Tools.pageLock()
      }
      const lottieTimer=setTimeout(() => {
        this.lottiePlay()
        clearTimeout(lottieTimer)
      }, 200);

        if(this.isIncome=='true'){
          // 控制唤起任务弹窗频次 一天一次
          // let today = new Date().toLocaleDateString();
          // if (window.localStorage && window.localStorage.getItem('today') != JSON.stringify(today)) {
          //   // 第二天 清空弹窗本地记录
          //   window.localStorage && window.localStorage.setItem('MISSION_FLAG', '');
          // }
          // let missionFlag = (window.localStorage && window.localStorage.getItem('MISSION_FLAG')) || '';
          // if (!(missionFlag == 'showed')) {
            const isIncomeTimer=setTimeout(() => {
           this.showMissionPanel()
          //  window.localStorage && window.localStorage.setItem('today', JSON.stringify(today));
            clearTimeout(isIncomeTimer)
           }, 500);
          // }
        }
       
    },
    lottiePlay() {
      if(this.showConfig.showLeftLottie&&this.showConfig.lottieUrl&&this.showConfig.lottieLink){
        let animationDom = this.$refs.leftLottie
      this.leftPlayer = lottie.loadAnimation({
        container: animationDom,
        renderer: 'svg', //"svg",
        name: 'leftPlayer',
        loop: true, //循环
        autoplay: true, //自动播放
        path:this.showConfig.lottieUrl,
      })
      }
    },
    handleClickLottie(link){
       this.$jumpUrl(link)
    },
    guideFinish() {
      this.guideShow = false
      Tools.pageUnlock()
      proHub.get('setSwitch', { position: '1' }, (e) => {
        this.gooseTalk(1)
      })
      if (this.needShowGiftEgg) {
        // console.log(1)
        this.showGiftEggs()
      }
    },
    handleActivity(link){
      this.$jumpUrl(link)
    },
    showMissionPanel() {
      // if (window && window.__qd__) {
      //   window.__qd__.imp({ cls: 'A05R|dsp_taskpage' })
      // }
      if(this.isStop){
        this.$jumpUrl('https://show.jd.com/m/X0eM/?pageKey=X0eM&channel=xiaxian')
      }else{
        this.missionShow = true
        Tools.pageLock()
      }
      
    },
    hideMissionPanel() {
      this.missionShow = false
      this.propShow = false
      Tools.pageUnlock()
    },
    showGoldOrder() {
      Tools.pageLock()
      this.goldOrderShow = true
    },
    dialogHide() {
      this.dialogShow = false
      this.goldOrderShow = false
      this.giftEggShow = false
      Tools.pageUnlock()
    },
    changePushStates() {
      //更换推送状态
      proHub.get('setSwitch', { position: '3' }, (e) => {
        if (e.code == '0000') {
          this.pushStates = !this.pushStates
          if (this.pushStates) {
            this.showToast('推送已开启')
          } else {
            this.showToast('推送已关闭')
          }
        }
      })
    },
    changeMusicStates() {
      proHub.get('setSwitch', { position: '2' }, (e) => {
        if (e.code == '0000') {
          this.musicStates = !this.musicStates
          this.musicBtn = !this.musicBtn
          if (this.musicStates) {
            this.$refs.soundBgm.play()
          } else {
            this.$refs.soundBgm.pause()
          }
        }
      })
    },
    getMissionReward(rewardNum) {
      this.eggNum += parseInt(rewardNum)
      this.getLevelInfo()
    },
    goldChange(e) {
      let self = this
        let canChangeGold
      if(this.isStop){
        canChangeGold = Math.ceil(this.eggNum / e.rate)
      }else{
        canChangeGold = parseInt(this.eggNum / e.rate)
      }
      let ajaxPending = false
      if (window && window.__qd__) {
        window.__qd__.imp({ cls: 'A05R|dsp_transfer' })
      }
      this.alertDialog({
        leftclstag: 'A05R|clk_transfer_no',
        rightclstag: 'A05R|clk_transfer_yes',
        leftBtnText: '暂不兑换',
        rightBtnText: '立即兑换',
        type: 1,
        eggNum: this.isStop?this.eggNum:canChangeGold * e.rate,
        canChangeGold: canChangeGold,
        rate: e.rate,
        rightBtnFn(cb) {
          if (ajaxPending) return
          let _this = this;
          
          let signData = {
            channelLv: Global.channelLv||"clv",
            environment: Global.currentSystem||"jrApp",
            riskDeviceInfo: Global.riskDeviceInfo,
            shareUuid: Global.inviteId||"uuid",
          };
          let parameters = {
          qdPageId: 'A05R',
          mdClickId: 'A05R|clk_transfer_yes',
          pageUrl: window.location.href,
          urlKey: window.location.origin + window.location.pathname,
          isSlider:0,
        };
          proHub.get(
            'toGoldExchange',
            {
              riskDeviceInfo: Global.riskDeviceInfo,
              parameters: parameters,
              environment: Global.currentSystem||"jrApp",
              channelLv: Global.channelLv||"clv",
              shareUuid: Global.inviteId||"uuid",
              sign: true,
              signData: signData,
            },
            (e) => {
              // console.log("toGoldExchange:",e);
              self.getUserType(e.code, () => {
                self.eggNum = e.data.availableTotal
                self.$refs.goldShop.refreshGold(e.data.goldTotal)
                cb()
                self.showToast('兑换成功')
              })
              ajaxPending = false
            }
          )
        },
      })
    },
    alertDialog(config) {
      Tools.pageLock()
      this.dialogShow = true
      this.dialogConfig = config
    },
    showToast(text) {
      this.toastShow = false
      this.$nextTick(() => {
        this.toastShow = true
        this.toastText = text
        setTimeout(()=>{
            this.toastShow = false
        },1300)
      })
    },
    collectEgg() {
      if (this.musicStates) {
        this.$refs.soundCollect.play()
      }
      this.playGooseMovie()

    },
    playGooseMovie() {
      //防刷功能
      let signData = {
        channelLv: Global.channelLv||"clv",
        environment: Global.currentSystem||"jrApp",
        riskDeviceInfo: Global.riskDeviceInfo,
        shareUuid: Global.inviteId||"uuid",
      };
      let parameters = {
          qdPageId: 'A05R',
          mdClickId: 'A05R|clk_getegg',
          pageUrl: window.location.href,
          urlKey: window.location.origin + window.location.pathname,
          isSlider:0,
        };
      //收蛋主动画
      let self = this
      gsap.registerPlugin(ScrollToPlugin)
      gsap.to(window, { duration: 0, scrollTo: 0 })
      Tools.pageLock()
      this.$refs.goose.playCollect(() => {
        Tools.pageUnlock()
        proHub.get(
          'toWithdraw',
          {
            riskDeviceInfo: Global.riskDeviceInfo,
            parameters: parameters,
            timeSign: Math.random(),
            environment: Global.currentSystem||"jrApp",
            channelLv: Global.channelLv||"clv",
            shareUuid: Global.inviteId||"uuid",
            signData: signData,
            sign: true,
          },
          (e) => {
            // console.log("toWithdraw返回:",e);
            this.getUserType(e.code, () => {
              this.eggNum = e.data.eggTotal
              this.collectEggNum = 0
              //双倍卡
              if (e.data.isDoubleCard) {
                this.showToast('收蛋数量已翻倍')
              }
              //收蛋逻辑
              if (e.data.createEgg == '0') {
                //还有蛋
                this.canCreateEgg = true
                this.nextEggTime = e.data.nextEggTime
                this.createEggTime(this.nextEggTime)
              } else {
                this.canCreateEgg = false
              }
              //额外奖励-提额包
              if (Global.currentSystem == 'jrApp') {
                //站内
                if (e.data.btObj) {
                  //有提额包
                  this.hasTodayPackage = false
                  this.alertDialog({
                    leftclstag: `A05R|clk_tc_${Global.currentSystem}_teb_1`,
                    rightclstag: `A05R|clk_tc_${Global.currentSystem}_teb_2`,
                    leftBtnText: '我知道了',
                    rightBtnText: '查看我的额度',
                    subDes: '白条额度提升成功',
                    type: 2,
                    packageNum: self.todayPackageNum,
                    rightBtnFn(cb) {
                      window.location.href = 'https://cfm.jd.com/jdbt/manage/pages/home.html?channelName=00008'
                    },
                    hideCb() {
                      self.getLevelInfo()
                    },
                  })
                } else {
                  self.getLevelInfo()
                }
              } else {
                if (this.hasTodayPackage) {
                  //有今日提额包
                  this.alertDialog({
                    leftclstag: `A05R|clk_tc_${Global.currentSystem}_teb_1`,
                    rightclstag: `A05R|clk_tc_${Global.currentSystem}_teb_2`,
                    leftBtnText: '我知道了',
                    rightBtnText: '去京东金融APP领取',
                    subDes: '仅限在京东金融APP中领取',
                    type: 2,
                    packageNum: self.todayPackageNum,
                    rightBtnFn(cb) {
                      window.location.href = 'https://u2.jr.jd.com/downloadApp/index.html?id=5813&activityId=3131'
                      cb()
                    },
                    hideCb() {
                      self.getLevelInfo()
                    },
                  })
                } else {
                  self.getLevelInfo()
                }
              }
              //额外奖励-优惠券
              if (e.data.yhqObj) {
                //有优惠券
                this.alertDialog({
                  leftclstag: `A05R|clk_tc_${Global.currentSystem}_yhq_1`,
                  rightclstag: `A05R|clk_tc_${Global.currentSystem}_yhq_2`,
                  leftBtnText: '我知道了',
                  rightBtnText: '查看我的优惠券',
                  prizeName: e.data.yhqObj.prizeName,
                  type: 3,
                  rightBtnFn(cb) {
                    window.location.href = 'https://m.jr.jd.com/member/mc/?channel=teyx#/home'
                  },
                  hideCb() {
                    self.getLevelInfo()
                  },
                })
              }
            })
          }
        )
      })
    },
    jumpToGoldFloor() {
      gsap.registerPlugin(ScrollToPlugin)
      gsap.to(window, { duration: 0.2, scrollTo: 400 })
    },

    //618期间事件
    /*showGiftEggs() {
                /!*  this.giftEggType = 1;
                  this.giftEggNum = 20;
                  this.giftEggShow = true;
                  return;*!/
                proHub.get('grantGiftPack', {
                    riskDeviceInfo: Global.riskDeviceInfo,
                    timeSign: Math.random(),
                    environment: Global.currentSystem,
                    channelLv: Global.channelLv,
                    shareUuid: Global.inviteId
                }, (e) => {
                    this.getUserType(e.code, () => {
                        this.giftEggType = e.data.prizeType | 0;
                        this.giftEggNum = e.data.prizeNum | 0;
                        this.giftEggShow = true;
                    })
                });
            },*/
    showPropPanel() {
      this.propShow = true
      Tools.pageLock()
    },

    // 关闭消息
    closeMessage () {
      this.scrollAnimate = true
    },
  },
}
</script>
